import React, { useEffect, useState } from "react";
import Instance from "../../AxiosConfig";
import { FaPlus } from "react-icons/fa";
import AddCompanyModal from "./AddCompanyModal";
import AddBankModal from "./AddBankModal";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import EditBankModal from "./EditBankModal";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Popconfirm,message } from "antd";
const BankDetails = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [showBankModal, setShowBankModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
  // ================= FETCH =================
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await Instance.get("/companyDetails");

      if (response.status === 200) {
        setData(response?.data?.data || []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const handleDeleteBank = async (companyId, bankId) => {
    try {
      await Instance.delete(`/companyDetails/${companyId}/banks/${bankId}`);
      message.success("Bank deleted");
      fetchData();
    } catch (err) {
      message.error(err?.response?.data?.message || "Error");
    }
  };
  return (
    <div className="agents-page mt-5">
      <div className="agents-table mt-3">
        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="agents-heading-h1">Company & Bank Details</h1>

          <button
            className="add-certification-btn"
            onClick={() => setShowCompanyModal(true)}
          >
            <FaPlus /> Add Company
          </button>
        </div>

        {/* DATA */}
        <div className="row mt-4">
          {loading ? (
            <p>Loading...</p>
          ) : data?.length > 0 ? (
            data.map((company) => (
              <div key={company._id} className="col-12 mb-4">
                <div className="card bank-card">
                  <div className="card-body">
                    {/* COMPANY HEADER */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5>{company.companyName}</h5>

                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => {
                          setSelectedCompany(company);
                          setShowBankModal(true);
                        }}
                      >
                        <FaPlus /> Add Bank
                      </button>
                    </div>

                    <div className="row">
                      {/* ================= COMPANY DETAILS ================= */}
                      <div className="col-lg-12 col-md-12">
                        <h6 className="mb-2">Company Details</h6>

                        <p>
                          <strong>Address:</strong>{" "}
                          {company.addressLine1 || "-"}
                        </p>
                        <p>
                          <strong>City:</strong> {company.city || "-"}
                        </p>
                        <p>
                          <strong>State:</strong> {company.state || "-"}
                        </p>
                        <p>
                          <strong>Pincode:</strong> {company.pincode || "-"}
                        </p>
                        <p>
                          <strong>Email:</strong> {company.email || "-"}
                        </p>
                        <p>
                          <strong>Phone:</strong> {company.phone || "-"}
                        </p>
                        <p>
                          <strong>GST Number:</strong>{" "}
                          {company.gstNumber || "-"}
                        </p>
                      </div>

                      {/* ================= BANK DETAILS ================= */}
                      <div className="col-12 mt-3">
                        <h6 className="mb-3">Bank Details</h6>

                        {company?.bankDetails?.length > 0 ? (
                          <div className="row">
                            {company.bankDetails.map((bank) => (
                              <div
                                key={bank._id}
                                className="col-md-6 col-lg-6 mb-3"
                              >
                                <div className="card p-3 position-relative h-100">
                                  {/* ACTION ICONS */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 10,
                                      right: 10,
                                      display: "flex",
                                      gap: "10px",
                                    }}
                                  >
                                    {/* EDIT */}
                                    <FaEdit
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setSelectedCompany(company);
                                        setSelectedBank(bank);
                                        setShowEditModal(true);
                                      }}
                                    />

                                    {/* DELETE */}
                                    <Popconfirm
                                      title="Are you sure to delete this bank?"
                                      onConfirm={() =>
                                        handleDeleteBank(company._id, bank._id)
                                      }
                                    >
                                      <FaTrash
                                        style={{
                                          cursor: "pointer",
                                          color: "red",
                                        }}
                                      />
                                    </Popconfirm>
                                  </div>

                                  {/* BANK INFO */}
                                  <p>
                                    <strong>Bank:</strong> {bank.bankName}
                                  </p>
                                  <p>
                                    <strong>Account:</strong>{" "}
                                    {bank.accountNumber}
                                  </p>
                                  <p>
                                    <strong>Country:</strong> {bank.country}
                                  </p>

                                  {bank.country === "India" ? (
                                    <>
                                      <p>
                                        <strong>IFSC Code:</strong>{" "}
                                        {bank.ifscCode || "-"}
                                      </p>
                                      <p>
                                        <strong>Beneficiary Name:</strong>{" "}
                                        {bank.beneficiaryName || "-"}
                                      </p>
                                      <p>
                                        <strong>SWIFT Code:</strong>{" "}
                                        {bank.swiftCode || "-"}
                                      </p>
                                       {/* <p>
                                    <strong>Currency:</strong>{" "}
                                    {bank.currency || "-"}
                                  </p> */}
                                      <p>
                                    <strong>Bank Address:</strong>{" "}
                                    {bank.branchAddress || "-"}
                                  </p>
                                    </>
                                  ) : (
                                    <>
                                      <p>
                                        <strong>Account Holder:</strong>{" "}
                                        {bank.accountHolderName || "-"}
                                      </p>
                                      <p>
                                        <strong>Routing Code:</strong>{" "}
                                        {bank.routingCode || "-"}
                                      </p>
                                      <p>
                                        <strong>Routing Type:</strong>{" "}
                                        {bank.routingType || "-"}
                                      </p>
                                      <p>
                                        <strong>Payment Method:</strong>{" "}
                                        {bank.paymentMethod || "-"}
                                      </p>
                                       {/* <p>
                                    <strong>Currency:</strong>{" "}
                                    {bank.currency || "-"}
                                  </p> */}
                                       <p>
                                    <strong>Bank Address:</strong>{" "}
                                    {bank.bankAddress || "-"}
                                  </p>
                                    </>
                                  )}

                                 
                                 

                                  <div>
                                    {bank.isDefault && (
                                      <span className="badge bg-success mt-2">
                                        Default
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="d-flex justify-content-between align-items-center">
                            <p>No Bank Added</p>

                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => {
                                setSelectedCompany(company);
                                setShowBankModal(true);
                              }}
                            >
                              <FaPlus /> Add Bank
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No Data Found</p>
          )}
        </div>
      </div>

      {/* ================= MODALS ================= */}

      <AddCompanyModal
        open={showCompanyModal}
        onClose={() => setShowCompanyModal(false)}
        refresh={fetchData}
      />

      <AddBankModal
        open={showBankModal}
        onClose={() => setShowBankModal(false)}
        company={selectedCompany}
        refresh={fetchData}
      />
      <EditBankModal
        open={showEditModal}
        onClose={() => setShowEditModal(false)}
        company={selectedCompany}
        bank={selectedBank}
        refresh={fetchData}
      />
    </div>
  );
};

export default BankDetails;
